// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3CwQl","content":"GlobalSearch_content__1Fit_"};